export const MOBILE_MAX_WIDTH = 768;

export const permissionLevels = {
  none: 0,
  thirdParty: 3,
  admin: 10,
  treasurer: 20,
  consultant: 21,
  webDesigner: 22,
  fundraiser: 40
}